import React, { useEffect, useState } from "react";
import { Controller, useForm } from "react-hook-form";
import { useTranslation } from "react-i18next";
import ButtonWrapper from "../../../components/Button";
import InputWrapper from "../../../layout/inputWrapper";
import {
  ConstructionTypeOptions,
  proposedSiteOptions,
  selfApprovalnatureOfConstruction,
  specialProjectOptions,
  yesOrNo,
} from "../../../../TCPForms/data";
import { InfoBox } from "../../../components/StyledComponent";
import { Col, Container, Row, Table } from "react-bootstrap";
import { Toast } from "@egovernments/digit-ui-react-components";
import useDepartmentSelector from "../../../../TCPForms/hooks/useDepartmentSelector";
import { Alert, Checkbox, FormControlLabel, Paper, Snackbar, TableBody, TableCell, TableContainer, TableHead, TableRow } from "@mui/material";
import { useHistory } from "react-router-dom";
import SortingAlphabatically from "../../../reusableComponents/SortingAlphbatically";
import DialogContentModal from "../../../../../../../../templates/ApplicationDetails/components/DialogContent";
import { set } from "lodash";
import useModal from "@egovernments/digit-ui-libraries/src/hooks/obps/SwalModals/useModal";

const SubStep1 = ({
  formData,
  handleSubTabChange,
  userInfo,
  handleTabChange,
  setProposedSite,
  schemeTypeData,
  nonSchemeTypeData,
  id,
  onSelect,
  initFormMTDocs,
  isEmployee,
  standardDesigns,
}) => {
  console.log("loggingFromEDCRPORTAL", nonSchemeTypeData, schemeTypeData);
  console.log(formData, "formDataFromSubStep1", standardDesigns);

  // Helper function for case-insensitive array includes
  const includesCaseInsensitive = (array, value) => {
    if (!array || !value) return false;
    console.log("includesCaseInsesitive", array.map((item) => item.toLowerCase()).includes(value.toLowerCase()), array, value);

    return array.map((item) => item.toLowerCase()).includes(value.toLowerCase());
  };

  const [, applicationFlow, DepartmentSelector] = useDepartmentSelector();
  const { t } = useTranslation();
  const [file, setFile] = useState(null);
  const stateId = Digit.ULBService.getStateId();
  const history = useHistory();

  const Modal = useModal();

  const designType = formData?.proposalType;
  const defaultValues = {
    ...formData,
    fastPASId: formData?.fastPASId,
    proposalType: formData?.proposalType,
    isSpecialProject: formData?.isSpecialProject,
    groundCoverages: formData?.groundCoverages,
    fars: formData?.fars,
    buildingHeight: formData?.buildingHeight,
    previousSetbackFront: formData?.setbackFronts,
    previousSetbackRear: formData?.setbackRears,
    natureOfConstructionOptions: formData?.natureOfConstructionOptions,
    planOn: "PURCHASABLE_MAP",
  };

  const { handleSubmit, control, setValue, watch, reset, getValues } = useForm({ defaultValues });
  const { data: districtData, isLoading: isDistrictDataLoading } = Digit.Hooks.useTenants();
  const updistricts = !isDistrictDataLoading && districtData?.filter((district) => !district.code?.includes("up"));
  const fetchedData = Digit.SessionStorage.get("FORM_PURCHASABLE_FAR") || null;
  const [fastPASData, setFastPasData] = useState(fetchedData ? fetchedData : null);
  const [purchasableData, setPurchasableData] = useState(null);
  const [user, setUser] = useState(null);
  const [riskType, setRiskType] = useState(null);
  const [showToast, setShowToast] = useState(null);
  const { data, isLoading: isDropDataLoading } = Digit.Hooks.obps.useMDMS(stateId, "MapSubmission", "DropdownsConfig");
  const dropDownData = !isDropDataLoading && data?.MapSubmission?.DropdownsConfig?.[0];
  const [schemeType, setSchemeType] = useState(false);
  const [declarationChecked, setDeclarationChecked] = useState(false);
  const [saveStatus, setSaveStatus] = useState({ open: false, message: "", severity: "error" });
  const [baseFAR, setBaseFAR] = useState(null);
  const [premiumFAR, setPremiumFAR] = useState(null);
  const [purchasableFAR, setPurchasableFAR] = useState(null);
  const [
    watchProposalType,
    watchisSpecialProject,
    watchTypeOfProject,
    watchPlotSubdivided,
    watchNeedComp,
    watchplotLeaseHold,
    watchisRevised,
    watchNoOfPLots,
    watchisApprovedLayout,
    watchisSetbackRequired,
    watchPlanOn,
    watchSpecialGroundCoverage,
    watchisSpecialFAR,
    watchProjectType,
    watchnatureOfConstruction,
    watchPrevFileNo,
    watchbuildingClassification,
    watchlandUseType,
    watchSubZoneType,
    watchPrimaryUse,
    watchAtivityProposed,
    watchSectorNo,
    watchLandMark,
    watchKhasraNo,
    watchTehsil,
    watchProposal,
    watchPlotArea,
    watchPlotNo,
    watchContainFar,
    watchFastPASId,
    watchBasicFAR,
    watchPurchasableFAR,
  ] = watch([
    "proposalType",
    "isSpecialProject",
    "typeOfProject",
    "plotSubdivided",
    "needCompounding",
    "plotLeaseHold",
    "isRevised",
    "noOfPlots",
    "isApprovedLayout",
    "isSetbackRequired",
    "planOn",
    "isSpecialGroundCoverage",
    "isSpecialFAR",
    "projectType",
    "natureOfConstruction",
    "prevFileNo",
    "buildingClassification",
    "zoneType",
    "subZoneType",
    "primaryUse",
    "activityProposed",
    "sectorNo",
    "landMark",
    "khasraNo",
    "tehsil",
    "proposal",
    "descriptionOfLand.schemeType",
    "plotNo",
    "containFAR",
    "fastPASId",
    "basicFAR",
    "purchasableFAR",
  ]);
  const watchedFields = watch();
  const mappedPlot = formData?.plotNumbers?.length;
  const [showDesigns, setShowDesigns] = useState(false);

  console.log("WAtchhsakPlot", watchPlotArea);

  const totalPlots = parseInt(watchNoOfPLots, 10) || parseInt(mappedPlot, 10) || 0;
  const isSelfCert =
    watchPlanOn === "Self Certification of residential Plot Area upto 300 SqM on approved layouts" ||
    watchPlanOn === "Self Approval via LTP of Residential Plot up to 500 sqm and Commercial plot up to 200 sqm";
  const isVillHide = watchProposal === "Scheme Developed by Authority" || watchProposal === "Scheme Approved by Authority";
  // Calculate the number of full rows (each with 5 plots) and any remaining plots
  const fullRows = Math.floor(totalPlots / 3);
  const remainingPlots = totalPlots % 3;
  let isMigrated = false;
  // Generate an array representing the plot inputs
  const plotInputs = Array.from({ length: totalPlots }, (_, index) => ({
    index: index + 1,
  }));
  const plotNumbers = plotInputs.map((plot) => watchedFields[`plotNumbers[${plot.index}]`]);
  useEffect(() => {
    if (formData) {
      reset({
        ...formData,
        fastPASId: formData?.fastPASId,
        natureOfConstructionOptions: formData?.natureOfConstructionOptions,
        proposalType: formData?.proposalType,
        isSpecialProject: formData?.isSpecialProject,
        groundCoverages: formData?.groundCoverages,
        fars: formData?.fars,
        buildingHeight: formData?.buildingHeight,
        previousSetbackFront: formData?.setbackFronts,
        previousSetbackRear: formData?.setbackRears,
      });
    }
  }, [formData]);

  // useEffect(() => {
  //   setValue("planOn", "Self Approval via LTP of Residential Plot up to 500 sqm and Commercial plot up to 200 sqm");
  // }, []);

  useEffect(() => {
    setValue("planOn", "Others");
  }, []);

  const columns = [
    { id: "srNo", label: "Sr No" },
    { id: "area", label: "Area (sqm)" },
    { id: "dimension", label: "Dimension" },
    { id: "type", label: "Type/Design" },
    { id: "construction", label: "Construction (GF/FF/SF)" },
  ];
  const pFARColumns = [
    { id: "submissionIndex", label: "Base FAR", accessor: "" },
    { id: "viewPdf", label: "Purchasable FAR", accessor: "documentType" },
    { id: "signedPdfUrl", label: "Premium FAR", accessor: "url" },
  ];
  const tableData = standardDesigns?.map((item, idx) => ({
    code: item.code ? item.code : "",
    srNo: idx + 1,
    area: item.areaSqm ? item.areaSqm : "-",
    dimension: item.dimension ? item.dimension : "-",
    type: item.typeDesign ? item.typeDesign : "-",
    construction: item.construction ? `GF: ${item.construction.GF}, FF: ${item.construction.FF}, SF: ${item.construction.SF}` : "-",
  }));
  useEffect(() => {
    if (watchnatureOfConstruction === "Revalidation/Time Extension") {
      history.push(`mapRevalidation`);
    }
  }, [watchnatureOfConstruction]);
  useEffect(() => {
    const retainedVlalues = { natureofConstruction: watchnatureOfConstruction, prevFileNo: watchPrevFileNo };
    Digit.SessionStorage.set("RETAINED_VALUES", retainedVlalues);
  }, [watchnatureOfConstruction, watchPrevFileNo]);
  useEffect(() => {
    //setProposedSite(watchPlanOn);
    const riskType =
      watchPlanOn === "Self Certification of residential Plot Area upto 300 SqM on approved layouts" ||
      watchPlanOn === "Self Approval via LTP of Residential Plot up to 500 sqm and Commercial plot up to 200 sqm"
        ? "Building Plan Low Risk, Self Certification Mode"
        : (watchlandUseType === "Residential" || watchSubZoneType === "Residential") &&
          watchAtivityProposed !== "Row Houses" &&
          watchAtivityProposed !== "Semi Detached" &&
          watchAtivityProposed !== "Detached"
        ? "High Risk and High Nivesh"
        : watchlandUseType === "Commercial"
        ? "High Risk and High Nivesh"
        : watchPlanOn !== "Others"
        ? "Building Plan-Low Risk"
        : "Others";

    setRiskType(riskType);
    const buildClass = riskType === "Building Plan Low Risk, Self Certification Mode" ? "Building Plan-Low Risk" : riskType;
    if (watchPlanOn) {
      setValue("buildingClassification", buildClass);
    }
    if (
      watchPlanOn === "Self Certification of residential Plot Area upto 300 SqM on approved layouts" ||
      watchPlanOn === "Self Approval via LTP of Residential Plot up to 500 sqm and Commercial plot up to 200 sqm"
    ) {
      setValue("noOfPlots", 1);
    }
  }, [watchPlanOn]);
  const closeToast = () => {
    setShowToast(null);
  };
  useEffect(() => {
    if (!showToast) return;
    const timeOut = setTimeout(closeToast, 3000);
    return () => clearTimeout(timeOut);
  }, [showToast]);

  useEffect(() => {
    if (watchContainFar === "yes") {
      setShowToast({
        key: "true",
        error: true,
        message: `Purchasable FAR is not allowed through Self-Approval via LTP. Kindly submit your application using the alternative map submission process`,
      });
    }
  }, [watchContainFar]);
  const selectedDesigns = watch("selectedDesigns") || [];

  useEffect(() => {
    Digit.SessionStorage.set("CHECKED_DESIGN", selectedDesigns);
  }, [JSON.stringify(selectedDesigns)]);
  const [checkedDesigns, setCheckedDesigns] = useState([]);

  // Update checkedDesigns from session storage when selectedDesigns changes or modal closes
  useEffect(() => {
    const stored = Digit.SessionStorage.get("CHECKED_DESIGN");
    setCheckedDesigns(stored || {});
  }, [showDesigns, JSON.stringify(selectedDesigns)]);
  const handleSearchClick = async (applicationNo) => {
    try {
      let response;
      let data;
      let purchasableData;
      if (applicationNo) {
        response = await Digit.OBPSService.BPAFastPASSearch({ land_Id: applicationNo });
        if (response?.BPA?.length === 0) {
          setShowToast({
            key: "true",
            error: true,
            message: `No Data Found for this FASTPAS ID...!!`,
          });
          return;
        } else if (response?.BPA?.[0]?.department !== applicationFlow) {
          setShowToast({
            key: "true",
            error: true,
            message: `Please use the selected department FASTPASID`,
          });
          return;
        }
        data = response?.BPA?.filter((item) => item.applicationType === "FORM_LANDUSE")?.[0];
        purchasableData = response?.BPA?.filter((item) => item.applicationType === "FORM_PURCHASABLE_FAR")?.[0];
        if (data) {
          const uuid = userInfo?.uuid;
          if (uuid) {
            const usersResponse = await Digit.UserService.userSearch(stateId, { uuid: [uuid] }, {});
            const userDetail = usersResponse?.user?.[0];
            Digit.SessionStorage.set("USER_DETAIL", userDetail);
            setUser(userDetail);
            if (data?.additionalDetails?.professionalInformation?.mobileNumber === userDetail?.mobileNumber) {
              setShowToast({
                key: "true",
                error: false,
                message: `Data fetched Successfully...!!`,
              });
            } else {
              setShowToast({
                key: "true",
                error: true,
                message: `Not Authorized to access this Id...!!`,
              });
              return;
            }
          }
          if (isSelfCert) {
            const propSite = data?.descriptionOfLand?.planOn;
            const primaryUseOfProp = data?.descriptionOfLand?.activityAsPerMap;
            const activityProp = data?.descriptionOfLand?.activityProposed;
            const plotArea = data?.descriptionOfLand?.landArea;
            if (primaryUseOfProp === "Residential" && activityProp === "Row Housing - Single units" && plotArea > 500) {
              setShowToast({
                key: "true",
                error: true,
                message: `Plot area shouldn't exceed 500sqmt, Please submit proposal through alternate process`,
              });
              return;
            }
            if (primaryUseOfProp === "Commercial" && plotArea > 200) {
              setShowToast({
                key: "true",
                error: true,
                message: `Plot area shouldn't exceed 200sqmt, Please submit proposal through alternate process`,
              });
              return;
            }
            if (primaryUseOfProp === "Residential" && activityProp === "Semi-Detached - Single Units" && plotArea !== 500) {
              setShowToast({
                key: "true",
                error: true,
                message: `Plot area should be equal to 500sqmt, Please submit proposal through alternate process`,
              });
              return;
            }
            if (data?.descriptionOfLand?.schemeType !== "Scheme") {
              setShowToast({
                key: "true",
                error: true,
                message: `Non Scheme Cases are not allowed here`,
              });
              return;
            }
          }
        }
        Digit.SessionStorage.set("FASTPAS_ID", data);
        setFastPasData(data);
        console.log("datafromfastpasid", data);

        setPurchasableData(purchasableData);
        setValue("zoneType", data?.descriptionOfLand?.landUsesType);
        setValue("primaryUse", data?.descriptionOfLand?.activityAsPerMap);
        setValue("landMark", data?.descriptionOfLand?.landMark);
        setValue("sectorNo", data?.descriptionOfLand?.sectorNo);
        setValue("khasraNo", data?.descriptionOfLand?.khasraWithArea[0]?.khasraNo);
        setValue("schemeName", data?.descriptionOfLand?.schemeName);
        setValue("proposal", data?.descriptionOfLand?.planOn);
        setValue("riskType", data?.riskType);
        setValue("activityProposed", data?.descriptionOfLand?.activityProposed);
        setValue("plotArea", data?.descriptionOfLand?.landArea);
        setValue("plotNo", data?.descriptionOfLand?.plotNo);
        setValue("plotAreaDoc", data?.descriptionOfLand?.plotAreaDoc);
        setValue("plotAreaPos", data?.descriptionOfLand?.plotAreaPossession);
        setValue("siteAddress", data?.descriptionOfLand?.landAddress);
        setValue("tehsil", data?.landInfo?.owners?.[0]?.permanentAddress?.tehsil);
        setValue("typeOfArea", data?.descriptionOfLand?.developmentArea);
        setValue("descriptionOfLand.schemeType", data?.descriptionOfLand?.schemeType);
        // setValue("department", data?.department);

        const isApproved = data?.descriptionOfLand?.schemeType === "Scheme";
        const plotArea = data?.descriptionOfLand?.landArea;
        setRiskType(data?.riskType);
        setSchemeType(isApproved);
        if (isApproved) {
          setValue("subZoneType", data?.descriptionOfLand?.subLandUseAsPerLayout);
        }
        if (!isApproved) {
          setValue("planOn", "Others");
        }
        if (plotArea > 40000) {
          setValue("shelterFee", "no");
        }
      }
    } catch (error) {
      console.error("Error occurred:", error);
    }
  };

  useEffect(() => {
    const roadWidth =
      parseInt(fastPASData?.descriptionOfLand?.approachRoadWidths?.[0]?.value) ||
      parseInt(formData?.descriptionOfLand?.approachRoadWidths?.[0]?.value) ||
      0;
    const activityProposed = fastPASData?.descriptionOfLand?.activityProposed || formData?.descriptionOfLand?.activityProposed || "";
    const developmentArea = fastPASData?.descriptionOfLand?.developmentArea || formData?.descriptionOfLand?.developmentArea || "";
    const plotArea = fastPASData?.descriptionOfLand?.landArea || formData?.descriptionOfLand?.landArea || 0;
    const allowableActivityProposed = [
      "Row Housing - Single units",
      "Semi-Detached - Single Units",
      "Detached - Single units",
      "Row Housing - Multi units",
      "Semi-detached - Multi Units",
      "Detached - Multi Units",
    ];
    const allowableDevelopmentArea = ["Built-up Area", "Non-Built-up Area"];
    const proposedBuiltUp = activityProposed === "Group Housing" && developmentArea === "Built-up Area";
    const proposedNonBuiltUp = activityProposed === "Group Housing" && developmentArea === "Non-Built-up Area";
    const proposedAffordableBuiltUp = activityProposed === "Group Housing - Affordable" && developmentArea === "Built-up Area";
    const proposedAffordableNonBuiltUp = activityProposed === "Group Housing - Affordable" && developmentArea === "Non-Built-up Area";
    console.log({ roadWidth, activityProposed, developmentArea, plotArea }, "roadWidthEffect");
    if (activityProposed === "Row Housing - Single units" && plotArea < 35) {
      setBaseFAR(2);
    } else if (
      includesCaseInsensitive(allowableActivityProposed, activityProposed) &&
      includesCaseInsensitive(allowableDevelopmentArea, developmentArea) &&
      plotArea >= 35 &&
      plotArea < 150
    ) {
      setBaseFAR(2);
      setPurchasableFAR(0.25);
    } else if (
      includesCaseInsensitive(allowableActivityProposed, activityProposed) &&
      includesCaseInsensitive(allowableDevelopmentArea, developmentArea) &&
      plotArea >= 150 &&
      plotArea < 300
    ) {
      setBaseFAR(1.8);
      setPurchasableFAR(0.7);
    } else if (
      includesCaseInsensitive(allowableActivityProposed, activityProposed) &&
      includesCaseInsensitive(allowableDevelopmentArea, developmentArea) &&
      plotArea >= 300 &&
      plotArea < 500
    ) {
      setBaseFAR(1.75);
      setPurchasableFAR(0.75);
    } else if (
      includesCaseInsensitive(allowableActivityProposed, activityProposed) &&
      includesCaseInsensitive(allowableDevelopmentArea, developmentArea) &&
      plotArea >= 500 &&
      plotArea < 1200
    ) {
      setBaseFAR(1.5);
      setPremiumFAR(1.0);
    } else if (
      includesCaseInsensitive(allowableActivityProposed, activityProposed) &&
      includesCaseInsensitive(allowableDevelopmentArea, developmentArea) &&
      plotArea >= 1200
    ) {
      setBaseFAR(1.25);
      setPurchasableFAR(1.25);
    }
    // group housing, roadwidth and built up area
    if (proposedBuiltUp && roadWidth < 12) {
      setBaseFAR(1.5);
      setPremiumFAR(0.3);
      setPurchasableFAR(0.3);
    } else if (proposedBuiltUp && roadWidth >= 12 && roadWidth < 24) {
      setBaseFAR(1.5);
      setPremiumFAR(0.75);
      setPurchasableFAR(0.75);
    } else if (proposedBuiltUp && roadWidth >= 24 && roadWidth < 45) {
      setBaseFAR(1.5);
      setPremiumFAR(1.5);
      setPurchasableFAR(2.25);
    } else if (proposedBuiltUp && roadWidth >= 45) {
      setBaseFAR(1.5);
      setPurchasableFAR(1.5);
      setPremiumFAR("Un-restricted");
    }
    // group housing, roadwidth and non built up area
    if (proposedNonBuiltUp && roadWidth < 12) {
    } else if (proposedNonBuiltUp && roadWidth >= 12 && roadWidth < 24) {
      setBaseFAR(2.5);
      setPremiumFAR(1.25);
      setPurchasableFAR(1.25);
    } else if (proposedNonBuiltUp && roadWidth >= 24 && roadWidth < 45) {
      setBaseFAR(2.5);
      setPremiumFAR(2.5);
      setPurchasableFAR(3.75);
    } else if (proposedNonBuiltUp && roadWidth >= 45) {
      setBaseFAR(2.5);
      setPurchasableFAR(2.5);
      setPremiumFAR("Un-restricted");
    }
    // affordable group housing built up area
    if (proposedAffordableBuiltUp && roadWidth < 12) {
      setBaseFAR(2.0);
      setPremiumFAR(0.2);
      setPurchasableFAR(0.2);
    } else if (proposedAffordableBuiltUp && roadWidth >= 12 && roadWidth < 24) {
      setBaseFAR(2.0);
      setPremiumFAR(1.0);
      setPurchasableFAR(1.0);
    } else if (proposedAffordableBuiltUp && roadWidth >= 24 && roadWidth < 45) {
      setBaseFAR(2.0);
      setPremiumFAR(2.0);
      setPurchasableFAR(3.0);
    } else if (proposedAffordableBuiltUp && roadWidth >= 45) {
      setBaseFAR(2.0);
      setPurchasableFAR(2.0);
      setPremiumFAR("Un-restricted");
    }
    // affordable group housing non built up area
    if (proposedAffordableNonBuiltUp && roadWidth >= 12 && roadWidth < 24) {
      setBaseFAR(3.0);
      setPremiumFAR(1.5);
      setPurchasableFAR(1.5);
    } else if (proposedAffordableNonBuiltUp && roadWidth >= 24 && roadWidth < 45) {
      setBaseFAR(3.0);
      setPremiumFAR(3.0);
      setPurchasableFAR(3.0);
    } else if (proposedAffordableNonBuiltUp && roadWidth >= 45) {
      setBaseFAR(3.0);
      setPurchasableFAR(3.0);
      setPremiumFAR("Un-restricted");
    }
    console.log({ baseFAR, purchasableFAR, premiumFAR }, "farImplementation");
  }, [watchFastPASId, watchAtivityProposed, watchPlotArea]);

  const handlePrevFileSearch = async (applicationNo) => {
    const retainedValues = Digit.SessionStorage.get("RETAINED_VALUES");
    if (!applicationNo) return;

    let response;
    let prevData;
    // If MS is present, use BPASearch, else use BPAmigratedSearchappNo
    if (applicationNo.includes("MS")) {
      console.log("inside MS");

      response = await Digit.OBPSService.BPASearch(stateId, { applicationNo });
      if (!response?.BPA?.length) {
        setShowToast({
          key: "true",
          error: true,
          message: `No Data Found for this FASTPAS ID...!!`,
        });
        return;
      }
      if (response?.BPA?.[0]?.department !== applicationFlow) {
        setShowToast({
          key: "true",
          error: true,
          message: `Please use the selected department FASTPASID`,
        });
        return;
      }
      if (
        response?.BPA?.[0]?.planOn !== "Self Certification of residential Plot Area upto 300 SqM on approved layouts" ||
        response?.BPA?.[0]?.planOn !== "Self Approval via LTP of Residential Plot up to 500 sqm and Commercial plot up to 200 sqm"
      ) {
        setSaveStatus({
          open: true,
          message: "Only Self Approved Map case type is allowed.",
          severity: "error",
        });
        return;
      }
      prevData = response?.BPA?.[0];
      prevData.natureOfConstruction = retainedValues?.natureofConstruction;
      prevData.prevFile = retainedValues?.prevFileNo;
      Digit.SessionStorage.set("PREV_FILE_DATA", prevData);
      isMigrated = false;
    } else {
      if (!applicationNo?.includes("SA-")) {
        setSaveStatus({
          open: true,
          message: "Only Self Approved Map case type is allowed.",
          severity: "error",
        });
        return;
      }
      console.log("inside migrated");
      response = await Digit.OBPSService.BPAmigratedSearchappNo({ applicationNo });
      Digit.SessionStorage.set("MIGRATED_DATA", response?.Application);
      setSaveStatus({
        open: true,
        message: "Data fetched Successfully...!!",
        severity: "success",
      });
      isMigrated = true;
    }

    onSelect("", prevData);
    initFormMTDocs(prevData?.documents);
    setValue("prevFileNo", applicationNo);

    // User authorization and modal logic
    if (prevData) {
      const uuid = userInfo?.uuid;
      if (uuid) {
        const usersResponse = await Digit.UserService.userSearch(stateId, { uuid: [uuid] }, {});
        const userDetail = usersResponse?.user?.[0];
        Digit.SessionStorage.set("USER_DETAIL", userDetail);
        setUser(userDetail);
        if (prevData?.professionaldetails?.mobileNumber !== userDetail?.mobileNumber) {
          setShowToast({
            key: "true",
            error: true,
            message: `Not Authorized to access this Id...!!`,
          });
          return;
        }
      }
      // Self-certification checks
      if (isSelfCert) {
        const { planOn: propSite, activityAsPerMap: primaryUseOfProp, activityProposed: activityProp, landArea: plotArea, schemeType } =
          prevData?.descriptionOfLand || {};
        if (primaryUseOfProp === "Residential" && activityProp === "Row Housing - Single units" && plotArea > 500) {
          setShowToast({
            key: "true",
            error: true,
            message: `Plot area shouldn't exceed 500sqmt, Please submit proposal through alternate process`,
          });
          return;
        }
        if (primaryUseOfProp === "Commercial" && plotArea > 200) {
          setShowToast({
            key: "true",
            error: true,
            message: `Plot area shouldn't exceed 200sqmt, Please submit proposal through alternate process`,
          });
          return;
        }
        if (primaryUseOfProp === "Residential" && activityProp === "Semi-Detached - Single Units" && plotArea !== 500) {
          setShowToast({
            key: "true",
            error: true,
            message: `Plot area should be equal to 500sqmt, Please submit proposal through alternate process`,
          });
          return;
        }
        if (schemeType !== "Scheme") {
          setShowToast({
            key: "true",
            error: true,
            message: `Non Scheme Cases are not allowed here`,
          });
          return;
        }
      }
    }
  };
  const filterSchemeData = (authority, masterData, category, subCategory) => {
    // First, find the relevant data once and store it
    const authorityData = masterData?.find((item) => item.name === authority);

    if (!authorityData) return { landUseList: [], landSubUseList: null }; // Return early if no authority data is found

    // Calculate landUseList, which doesn't depend on category
    const landUseList =
      authorityData?.LandUse?.map((item) => ({
        name: item.Type,
        value: item.Type,
      })) || []; // Fallback to an empty array if no LandUse is found

    let landSubUseList = null;

    // Only calculate landSubUseList if category is provided
    if (category) {
      const landUseCategory = authorityData?.LandUse?.find((item) => item.Type === category);

      // Only process if the specific category is found
      if (landUseCategory) {
        landSubUseList =
          landUseCategory.LandSubUse?.map((item) => ({
            name: item,
            label: item,
          })) || []; // Fallback to empty array if LandSubUse is not found
      }
    }

    console.log("loggingMasterData", landUseList, landSubUseList);

    return { landUseList, landSubUseList };
  };
  const handleCloseMessage = () => {
    setSaveStatus({ ...saveStatus, open: false });
  };
  const filterNonSchemeData = (authority, masterData, category, subCategory) => {
    console.log("FromNonschemeDataCalled", masterData, category);

    const landUseList = masterData?.[0]?.CategeryType?.map((item) => {
      return { name: item.Categery, label: item.Categery };
    });
    const landSubUseList = masterData?.[0]?.CategeryType?.filter((item) => item.Categery === category)?.[0]?.["Activity Proposed"]?.map((item) => {
      return { name: item, label: item };
    });

    console.log("NonschemeDataCalled");
    console.log("nonSchemList", landUseList, landSubUseList);
    return { landUseList, landSubUseList };
  };
  const { landUseList, landSubUseList } = !schemeType
    ? filterSchemeData(fastPASData?.selectedOffice, schemeTypeData, watchlandUseType, watchSubZoneType)
    : filterNonSchemeData(fastPASData?.selectedOffice, nonSchemeTypeData, watchlandUseType, watchSubZoneType);
  console.log(schemeType, "schemeTypeerrrrr");

  const handleDeclarationChange = (event) => {
    setDeclarationChecked(event.target.checked);
  };
  useEffect(() => {
    // Find the selected design
    const selectedDesignsObj = watch("selectedDesigns") || {};
    const selectedKey = Object.entries(selectedDesignsObj).find(([key, value]) => value)?.[0];
    let selectedDesign = null;
    if (selectedKey && standardDesigns) {
      selectedDesign = standardDesigns.find((item, idx) => (item.code ? String(item.code) : String(idx)) === selectedKey);
    }
    // If a design is selected, set the anyotherCondition field
    if (selectedDesign && selectedDesign?.construction) {
      const floors = Object.entries(selectedDesign.construction)
        .filter(([floor, val]) => val === "Y")
        .map(([floor]) => floor)
        .join(", ");
      setValue("anyotherCondition", floors);
    }
  }, [watch("selectedDesigns"), standardDesigns, setValue]);
  const onSubmit = (data) => {
    console.log("SubmittedDAta", data, typeof watchBasicFAR, typeof watchPurchasableFAR, watchBasicFAR, watchPurchasableFAR);
    if (Number(watchBasicFAR) + Number(watchPurchasableFAR) > 2.5) {
      Modal(
        "Invalid Values",
        `Your Basic FAR and Purchasable FAR Factors value are exceeding 2.50. Please Correct them before proceeding.`,
        "warning"
      );
      return;
    }
    if (data?.prevFileNo?.includes("SA-")) {
      console.log("inside SA-");
      const migratedData = Digit.SessionStorage.get("MIGRATED_DATA");
      data.department = data?.prevFileNo?.includes("DA") ? "DA" : "AVP";
      (data.tenantId = stateId),
        (data.businessService = "BPA_MAPSUB_DA"),
        (data.landInfo = {
          ...data?.landInfo,
          tenantId: stateId,
          address: {
            ...data?.landInfo?.address,
            locality: {
              code: migratedData?.projectDetail?.district,
            },
          },
        });
      handleSubTabChange(1, data);
      return;
    }
    const fastPasdata = Digit.SessionStorage.get("FASTPAS_ID");
    const prevFileData = Digit.SessionStorage.get("PREV_FILE_DATA");
    if (watchnatureOfConstruction !== "New") {
      handleSubTabChange(1, prevFileData);
      return;
    }
    if (id) {
      const newFormData = { ...formData, ...data };
      console.log(formData, data, "editformdata");
      handleSubTabChange(1, newFormData);
      return;
    }
    const newFormData = {
      landInfo: {
        ...(!id && (fastPasdata?.landInfo || prevFileData?.landInfo || {})),
      },
      tenantId: stateId,
      land_Id: fastPasdata?.land_Id,
      documents: fastPasdata?.documents,
      descriptionOfLand: fastPasdata?.descriptionOfLand,
      nocDetails: fastPasdata?.nocDetails,
      occupancy: data?.zoneType,
      totalProposedArea: fastPASData?.descriptionOfLand?.landArea,
    };
    const selectedDesignsObj = data.selectedDesigns || {};
    const selectedKey = Object.entries(selectedDesignsObj).find(([key, value]) => value)?.[0];

    let selectedDesign = null;
    if (selectedKey && standardDesigns) {
      selectedDesign = standardDesigns.find((item, idx) => (item.code ? String(item.code) : String(idx)) === selectedKey);
    }

    data.selectedDesign = selectedDesign || null;
    data.selectedOffice = fastPASData?.additionalDetails?.selectedOffice || prevFileData?.selectedOffice || "";
    data.selectedCity = fastPASData?.additionalDetails?.selectedCity || "";
    data.selectedUnit = fastPASData?.additionalDetails?.selectedUnit || "";
    data.landUseNo = fastPASData?.applicationNo;
    data.department = fastPASData?.department || prevFileData?.department || applicationFlow;
    //data.purchasableFAR = fastPASData?.descriptionOfLand?.properties?.[0]?.requiredAreaFAR || 0;
    data.fastPASId = fastPASData?.land_Id;
    (data.plotArea = fastPASData?.descriptionOfLand?.landArea), (data = { ...data, ...newFormData });
    if (!id) {
      (data.plotNumbers = plotNumbers), (data.applicantName = fastPASData?.landInfo?.owners?.[0]?.name || "");
      data.applicantEmailId = fastPASData?.landInfo?.owners?.[0]?.emailId || "";
      data.aplicantMobileNumber = fastPASData?.landInfo?.owners?.[0]?.mobileNumber || "";
      data.selectedOffice = fastPASData?.additionalDetails?.selectedOffice || "";
      data.selectedCity = fastPASData?.additionalDetails?.selectedCity || "";
      data.selectedUnit = fastPASData?.additionalDetails?.selectedUnit || "";
      data.landUseNo = fastPASData?.applicationNo;
      // data.purchasableFAR = purchasableData?.descriptionOfLand?.properties?.[0]?.requiredAreaFAR || 0;
      data.fastPASId = fastPASData?.land_Id;
      data.signatureId = fastPASData?.documents?.filter((doc) => doc.documentType === "signature")[0]?.fileStoreId || null;
      (data.licenseeName = user?.name), (data.licenseeLicenceNumber = user?.registrationNumber);
      data.licenseeMobileNumber = user?.mobileNumber;
      data.licenseeEmailId = user?.emailId;
      data.licenseeAddress = user?.correspondenceAddress?.address;
    }
    data.businessService = applicationFlow === "DA" ? "BPA_PURCHASEFAR_DA" : "BPA_PURCHASEFAR_AVP";

    handleSubTabChange(1, data);
  };
  if (applicationFlow === null && !isEmployee) {
    return <DepartmentSelector />;
  }
  return (
    <section className="groupContainer2">
      <form onSubmit={handleSubmit(onSubmit)}>
        <div className="formContainer">
          <div className="formHeaderContainer">
            <h2 className="formHeading">{t("Application Form")}</h2>
          </div>
          <Container fluid className="formInputContainer common-app-form">
            <Row>
              <Col>
                <InputWrapper
                  control={control}
                  label={t("Nature of Construction / Case Type")}
                  placeholder={t("Select Nature Of Construction")}
                  name="natureOfConstruction"
                  defaultValue={formData?.natureOfConstruction}
                  data={SortingAlphabatically(selfApprovalnatureOfConstruction)}
                  type="selectInput"
                  disabled={isEmployee}
                  mandatory
                  validation={{
                    required: {
                      value: true,
                      message: "This field is required",
                    },
                  }}
                />
              </Col>
              {watchnatureOfConstruction && watchnatureOfConstruction !== "New" ? (
                <Col>
                  <InputWrapper
                    label={t("Prev File No")}
                    control={control}
                    placeholder={t("Enter File No")}
                    name="prevFileNo"
                    mandatory
                    maxLength={23}
                    defaultValue={formData?.prevFileNo}
                    disabled={isEmployee}
                    type="textInput"
                    validation={{
                      required: {
                        value: true,
                        message: "This field is required",
                      },
                    }}
                    showSearchIcon={true}
                    onSearchClick={() => handlePrevFileSearch(getValues("prevFileNo"))}
                  />
                </Col>
              ) : (
                <Col>
                  <InputWrapper
                    control={control}
                    label="FASTPAS ID"
                    placeholder="Enter FASTPAS ID."
                    name="fastPASId"
                    type="textInput"
                    mandatory
                    defaultValue={formData?.fastPASId}
                    disabled={isEmployee}
                    validation={{
                      required: {
                        value: true,
                        message: "This field is required",
                      },
                    }}
                    showSearchIcon={true}
                    onSearchClick={() => handleSearchClick(getValues("fastPASId"))}
                  />
                </Col>
              )}
            </Row>
            {watchnatureOfConstruction === "Revalidation" && (
              <Row>
                <Col>
                  <InputWrapper
                    control={control}
                    label={t("Previous Sanction Date")}
                    placeholder={t("Select Prev Sanction Date")}
                    name="prevSanctionDate"
                    defaultValue={formData?.prevSanctionDate}
                    type="datePicker"
                    mandatory
                    validation={{
                      required: {
                        value: true,
                        message: "This field is required",
                      },
                    }}
                    disabled={isEmployee}
                  />
                </Col>
                <Col>
                  <InputWrapper
                    control={control}
                    label={t("Current Validity Date")}
                    placeholder={t("Select Date")}
                    name="currValidityDate"
                    defaultValue={formData?.currValidityDate}
                    type="datePicker"
                    mandatory
                    validation={{
                      required: {
                        value: true,
                        message: "This field is required",
                      },
                    }}
                    disabled={isEmployee}
                  />
                </Col>
              </Row>
            )}
            <Row>
              <Col>
                <InputWrapper
                  control={control}
                  data={SortingAlphabatically(landUseList)}
                  label={t("Land Use")}
                  placeholder={t("Select Type of Land")}
                  name="zoneType"
                  defaultValue={formData?.zoneType}
                  type="selectInput"
                  mandatory
                  validation={{
                    required: {
                      value: true,
                      message: "This field is required",
                    },
                  }}
                  disabled={!!watchlandUseType || isEmployee}
                />
              </Col>
              <Col>
                <InputWrapper
                  control={control}
                  data={SortingAlphabatically(landSubUseList)}
                  label={t("Land Sub Use")}
                  placeholder={t("Select Type of Land Subuse")}
                  name="subZoneType"
                  defaultValue={formData?.descriptionOfLand?.subLandUseAsPerLayout || formData?.subZoneType}
                  type="selectInput"
                  mandatory
                  validation={{
                    required: {
                      value: true,
                      message: "This field is required",
                    },
                  }}
                  disabled={(schemeType && watchSubZoneType) || isEmployee}
                />
              </Col>
            </Row>

            <Row>
              <Col>
                <InputWrapper
                  control={control}
                  data={SortingAlphabatically(landUseList)}
                  label={t("Primary Use of Proposed Activity")}
                  placeholder={t("Select Primary Use of Proposed Activity")}
                  name="primaryUse"
                  defaultValue={formData?.primaryUse}
                  type="selectInput"
                  mandatory
                  validation={{
                    required: {
                      value: true,
                      message: "This field is required",
                    },
                  }}
                  disabled={!!watchPrimaryUse || isEmployee}
                />
              </Col>
              <Col>
                <InputWrapper
                  control={control}
                  data={SortingAlphabatically(landSubUseList)}
                  label={t("Activity proposed")}
                  placeholder={t("Select Type of Activity proposed")}
                  name="activityProposed"
                  defaultValue={formData?.activityProposed}
                  type="selectInput"
                  mandatory
                  validation={{
                    required: {
                      value: true,
                      message: "This field is required",
                    },
                  }}
                  disabled={!!watchAtivityProposed || isEmployee}
                />
              </Col>
            </Row>
            <Row>
              <Col>
                <InputWrapper
                  label={"Scheme Type"}
                  control={control}
                  placeholder={t("Select Scheme Type")}
                  name="descriptionOfLand.schemeType"
                  mandatory
                  defaultValue={formData?.descriptionOfLand?.schemeType}
                  type="textInput"
                  disabled={watchPlotArea || isEmployee}
                />
              </Col>
              {watchPlotArea !== "Non Scheme" ? (
                <Col>
                  {" "}
                  <InputWrapper
                    control={control}
                    data={SortingAlphabatically(proposedSiteOptions.filter((e) => e.name !== "Others"))}
                    label={t("Proposed Site")}
                    placeholder={t("Proposed Site")}
                    name="proposal"
                    defaultValue={formData?.proposal}
                    type="selectInput"
                    mandatory={schemeType}
                    validation={{
                      required: {
                        value: schemeType,
                        message: "This field is required",
                      },
                    }}
                    disabled={!!watchProposal || isEmployee}
                  />
                </Col>
              ) : (
                <Col></Col>
              )}
            </Row>
            {watchPlotArea !== "Non Scheme" && (
              <Row>
                <Col>
                  <InputWrapper
                    label="Scheme Name"
                    control={control}
                    placeholder="Select Scheme Name"
                    defaultValue={formData?.schemeName}
                    name={`schemeName`}
                    type="selectInput"
                    mandatory
                    data={SortingAlphabatically(dropDownData?.schemeName)}
                    validation={{
                      required: {
                        value: true,
                        message: "This field is required",
                      },
                    }}
                    disabled={fastPASData?.descriptionOfLand?.schemeName || isEmployee}
                  />
                </Col>
                <Col></Col>
                {/* <InputWrapper
                                control={control}
                                data={updistricts}
                                label={t("District")}
                                placeholder={t("Select District")}
                                defaultValue={formData?.district}
                                name={`district`}
                                type="selectInput"
                                mandatory
                                validation={{
                                    required: {
                                        value: true,
                                        message: "This field is required"
                                    }
                                }}
                            /> */}
                {/* {!isVillHide ? (
                <Col>
                  {" "}
                  <InputWrapper
                    label={t("Tehsil")}
                    control={control}
                    placeholder={t("Enter Tehsil")}
                    name="tehsil"
                    defaultValue={formData?.tehsil}
                    type="textInput"
                    disabled={!!watchTehsil}
                    validation={{
                      required: {
                        value: !schemeType,
                        message: "This field is required",
                      },
                    }}
                    mandatory={!schemeType}
                  />
                </Col>
              ) : (
                <Col></Col>
              )} */}
              </Row>
            )}
            {/* <Row>
              <Col>
                <InputWrapper
                  label={t("Layout Sanction No.")}
                  control={control}
                  placeholder={t("Enter layout sanction number")}
                  name="layoutsanctionNumber"
                  defaultValue={formData?.layoutsanctionNumber}
                  type="textInput"
                  disabled={isEmployee}
                />
              </Col>
              <Col>
                <InputWrapper
                  label={t("Layout Sanction Date")}
                  control={control}
                  placeholder={t("Enter Layout Sanction date")}
                  name="layoutsanctionDate"
                  defaultValue={formData?.layoutsanctionDate}
                  type="datePicker"
                  disabled={isEmployee}
                />
              </Col>
            </Row> */}
            <Row>
              {watchPlanOn === "Others" ? (
                <Col>
                  <InputWrapper
                    label={t("Development Area")}
                    control={control}
                    placeholder={t("Select Development Area Type")}
                    data={SortingAlphabatically(ConstructionTypeOptions)}
                    name="constructionType"
                    mandatory
                    disabled={isEmployee}
                    defaultValue={formData?.constructionType}
                    type="selectInput"
                    validation={{
                      required: {
                        value: true,
                        message: "This field is required",
                      },
                    }}
                  />
                </Col>
              ) : (
                <Col></Col>
              )}
              <Col></Col>
            </Row>

            {/* <Row>
              {!isVillHide && (
                <Col>
                  <InputWrapper
                    label="Revenue Village/Colony Name"
                    control={control}
                    placeholder="Enter Revenue Village"
                    defaultValue={formData?.revenueVillage}
                    name={`revenueVillage`}
                    type="textInput"
                    mandatory={!schemeType}
                    validation={{
                      required: {
                        value: !schemeType,
                        message: "This field is required",
                      },
                    }}
                  />
                </Col>
              )}
            </Row> */}
            <Row>
              <Col>
                <InputWrapper
                  label={t("Sector/Pocket No.")}
                  control={control}
                  placeholder={t("Enter Sector/Pocket No.")}
                  name="sectorNo"
                  mandatory={!schemeType}
                  maxLength={15}
                  defaultValue={formData?.sectorNo}
                  disabled={isEmployee}
                  type="textInput"
                  validation={{
                    required: {
                      value: !schemeType,
                      message: "This field is required",
                    },
                  }}
                />
              </Col>
              {/* {!isVillHide && (
                <Col>
                  <InputWrapper
                    label={t("Khasra No.")}
                    control={control}
                    placeholder={t("Enter Khasra No.")}
                    name="khasraNo"
                    mandatory={!schemeType}
                    maxLength={15}
                    defaultValue={formData?.khasraNo}
                    type="textInput"
                    validation={{
                      required: {
                        value: !schemeType,
                        message: "This field is required",
                      },
                    }}
                  />
                </Col>
              )} */}
              <Col>
                <InputWrapper
                  label={t("Land Mark")}
                  control={control}
                  placeholder={t("Enter Land Mark")}
                  name="landMark"
                  mandatory={!schemeType}
                  maxLength={15}
                  defaultValue={formData?.landMark}
                  type="textInput"
                  disabled={watchLandMark || isEmployee}
                  validation={{
                    required: {
                      value: !schemeType,
                      message: "This field is required",
                    },
                  }}
                />
              </Col>
            </Row>

            <Row>
              {/* <Col>
                <InputWrapper
                  control={control}
                  label={`${t("Standard Type Design")}`}
                  name="proposalType"
                  defaultValue={formData?.proposalType || designType}
                  type="radioButton"
                  mandatory
                  data={yesOrNo}
                  validation={{
                    required: {
                      value: true,
                      message: "This field is required",
                    },
                  }}
                />
              </Col> */}
              <Col>
                <InputWrapper
                  label={t("Plot No")}
                  control={control}
                  placeholder={t("Enter Plot no")}
                  name="plotNo"
                  mandatory
                  defaultValue={formData?.plotNo}
                  type="textInput"
                  disabled={formData?.plotNo || isEmployee}
                />
              </Col>
              <Col>
                <InputWrapper
                  label={"Plot Area as per Site (in Sqmt.)"}
                  control={control}
                  placeholder={t("Enter Plot Area")}
                  name="plotArea"
                  mandatory
                  defaultValue={formData?.plotArea}
                  type="textInput"
                  disabled={watchPlotArea || isEmployee}
                />
              </Col>
            </Row>
            <Row>
              {watchProposalType === "yes" && (
                <Col>
                  <InputWrapper
                    label={t("Sanction date of layout")}
                    control={control}
                    placeholder={t("Enter Sanction date Of layout")}
                    name="sanctionDate"
                    mandatory
                    defaultValue={formData?.sanctionDate}
                    type="datePicker"
                    disabled={isEmployee}
                  />
                </Col>
              )}
              {watchProposalType === "yes" && (
                <Col>
                  <InputWrapper
                    label={t("Sanction number of layout")}
                    control={control}
                    placeholder={t("Enter Sanction number Of layout")}
                    name="sanctionNumber"
                    mandatory
                    defaultValue={formData?.sanctionNumber}
                    type="textInput"
                    disabled={isEmployee}
                  />
                </Col>
              )}
            </Row>
            {/* No Of Plots mapping  */}
            {watchProposalType === "yes" && (
              <Row>
                <Col>
                  {" "}
                  <InputWrapper
                    label={t("No. Of Plots")}
                    control={control}
                    placeholder={t("Enter No. Of Plots")}
                    name="noOfPlots"
                    mandatory
                    defaultValue={formData?.noOfPlots}
                    type="textInput"
                    disabled={isEmployee}
                  />
                </Col>
                <Col></Col>
              </Row>
            )}

            {watchProposalType === "yes" && (
              <React.Fragment>
                {/* Full rows */}
                {Array.from({ length: fullRows }).map((_, rowIndex) => (
                  <Row key={rowIndex}>
                    {Array.from({ length: 3 }).map((_, colIndex) => {
                      const plotIndex = rowIndex * 3 + colIndex;
                      return (
                        <Col key={`plot-${plotIndex}`}>
                          <InputWrapper
                            control={control}
                            placeholder={t("Enter Plot No")}
                            name={`plotNumbers.${plotIndex}`} // Use dot notation
                            mandatory
                            hasLabel={false}
                            maxLength={15}
                            defaultValue={formData?.plotNumbers?.[plotIndex] || ""}
                            type="textInput"
                            disabled={isEmployee}
                          />
                        </Col>
                      );
                    })}
                  </Row>
                ))}

                {/* Remaining plots */}
                {remainingPlots > 0 && (
                  <Row key={fullRows}>
                    {Array.from({ length: remainingPlots }).map((_, colIndex) => {
                      const plotIndex = fullRows * 3 + colIndex;
                      return (
                        <Col key={`plot-${plotIndex}`}>
                          <InputWrapper
                            control={control}
                            placeholder={t("Enter Plot No")}
                            name={`plotNumbers.${plotIndex}`} // Use dot notation
                            mandatory
                            maxLength={15}
                            hasLabel={false}
                            defaultValue={formData?.plotNumbers?.[plotIndex] || ""}
                            type="textInput"
                            disabled={isEmployee}
                          />
                        </Col>
                      );
                    })}
                  </Row>
                )}
              </React.Fragment>
            )}
            {/* 
            <Row>
              <Col>
                <InputWrapper
                  control={control}
                  data={watchPlanOn === "Others" ? projectTypeOptions.filter((e) => e.name !== "Building Permission-Low Risk") : projectTypeOptions}
                  label={`${t("Project Type")}`}
                  placeholder={"Select Project Type"}
                  name="buildingClassification"
                  defaultValue={formData?.buildingClassification}
                  type={watchPlanOn ? "textInput" : "selectInput"}
                  mandatory
                  validation={{
                    required: {
                      value: true,
                      message: "This field is required",
                    },
                  }}
                  disabled={!!watchPlanOn}
                />
              </Col>
              <Col>
                {watchbuildingClassification === "Others" && (
                  <Col>
                    <InputWrapper
                      label={t("Other Project")}
                      control={control}
                      placeholder={t("Enter  Name")}
                      name="otherbuildingClass"
                      mandatory
                      isRequired={true}
                      defaultValue={formData?.otherbuildingClass}
                      type="textInput"
                      validation={{
                        required: {
                          value: true,
                          message: "This field is required",
                        },
                      }}
                    />
                  </Col>
                )}
              </Col>
            </Row> */}

            {/* {watchnatureOfConstruction !== 'New' && <Row>
                            <Col><InputWrapper
                                control={control}
                                data={dropDownData?.yesOrNo}
                                label={t("Is Revised")}
                                placeholder={t("Is Revised")}
                                name="isRevised"
                                defaultValue={formData?.isRevised}
                                type="radioButton"
                                mandatory
                                validation={{
                                    required: {
                                        value: true,
                                        message: "This field is required"
                                    }
                                }}
                            />
                            </Col>
                            {watchisRevised === 'yes' && <Col>
                                <InputWrapper
                                    label={t("Prev File No")}
                                    control={control}
                                    placeholder={t("Enter File No")}
                                    name="prevFileNo"
                                    mandatory
                                    maxLength={15}
                                    defaultValue={formData?.prevFileNo}
                                    type="textInput"
                                /></Col>
                            }
                        </Row>} */}
            <Row>
              <Col>
                <InputWrapper
                  control={control}
                  label={`${t("Special Project type")}`}
                  name="isSpecialProject"
                  defaultValue={formData?.isSpecialProject}
                  type="radioButton"
                  data={yesOrNo}
                  disabled={isEmployee}
                  mandatory
                  validation={{
                    required: {
                      value: true,
                      message: "This field is required",
                    },
                  }}
                />
              </Col>
              <Col>
                {" "}
                {(watchlandUseType !== "Residential" || watchPrimaryUse !== "Residential") && (
                  <InputWrapper
                    control={control}
                    data={yesOrNo}
                    label={t("If Community Parking Provided")}
                    placeholder={t("Select Community Parking")}
                    name="communityParking"
                    defaultValue={formData?.communityParking}
                    type="selectInput"
                    mandatory
                    disabled={isEmployee}
                    validation={{
                      required: {
                        value: true,
                        message: "This field is required",
                      },
                    }}
                  />
                )}
              </Col>
            </Row>
            {watchisSpecialProject === "yes" && (
              <Row>
                <Col>
                  <InputWrapper
                    label={t("Special Condition of Project")}
                    control={control}
                    placeholder={t("Select Condition of Project")}
                    data={SortingAlphabatically(specialProjectOptions)}
                    name="projectType"
                    mandatory
                    disabled={isEmployee}
                    defaultValue={formData?.projectType}
                    type="selectInput"
                  />
                </Col>
                <Col>
                  {watchProjectType === "Other" && (
                    <Col>
                      <InputWrapper
                        label={t("Other Project")}
                        control={control}
                        placeholder={t("Enter  Name")}
                        name="otherProjectName"
                        mandatory
                        disabled={isEmployee}
                        defaultValue={formData?.otherProjectName}
                        type="textInput"
                      />
                    </Col>
                  )}
                </Col>
              </Row>
            )}
            {watchisSpecialProject === "yes" && watchProjectType === "Building Design as per standard Drawing" && (
              <Row>
                <Col>
                  <button
                    type="button"
                    className="btn btn-primary"
                    style={{ marginBottom: "16px", background: "#1F4A7C" }}
                    onClick={() => setShowDesigns(true)}
                  >
                    View Standard Designs
                  </button>
                </Col>

                <DialogContentModal title={t("Standard Designs")} dataOpen={showDesigns} onClose={() => setShowDesigns(false)}>
                  <Row>
                    <Col>
                      <TableContainer component={Paper} className="table-container" sx={{ marginTop: 2 }}>
                        <caption className="emp-table-caption">Standard Designs</caption>
                        <Table stickyHeader className="application-table">
                          <thead>
                            <tr>
                              {columns.map((col) => (
                                <td key={col.id}>
                                  <b>{col.label}</b>
                                </td>
                              ))}
                              <td>
                                <b>{t("Select")}</b>
                              </td>
                            </tr>
                          </thead>
                          <tbody>
                            {tableData?.length === 0 ? (
                              <tr>
                                <td colSpan={columns.length + 1} align="center">
                                  No Standard Designs Available
                                </td>
                              </tr>
                            ) : (
                              tableData?.map((row, idx) => (
                                <tr key={row.code}>
                                  <td>{row.srNo}</td>
                                  <td>{row.area}</td>
                                  <td>{row.dimension}</td>
                                  <td>{row.type}</td>
                                  <td>{row.construction}</td>
                                  <td>
                                    <Controller
                                      name={`selectedDesigns.${row.code}`}
                                      control={control}
                                      defaultValue={false}
                                      render={({ field }) => (
                                        <Checkbox {...field} checked={!!field.value} onChange={(e) => field.onChange(e.target.checked)} />
                                      )}
                                    />
                                  </td>
                                </tr>
                              ))
                            )}
                          </tbody>
                        </Table>
                      </TableContainer>
                    </Col>
                  </Row>
                </DialogContentModal>
              </Row>
            )}
            {checkedDesigns && Object.keys(checkedDesigns)?.length > 0 && (
              <Row>
                <Col>
                  <TableContainer component={Paper} className="table-container" sx={{ marginTop: 2, marginBottom: 2, padding: "4px" }}>
                    <caption className="emp-table-caption" style={{ width: "172px" }}>
                      Selected Designs
                    </caption>
                    <Table stickyHeader className="application-table">
                      <thead>
                        <tr>
                          <td>
                            <b>Sr No</b>
                          </td>
                          <td>
                            <b>Area (sqm)</b>
                          </td>
                          <td>
                            <b>Dimension</b>
                          </td>
                          <td>
                            <b>Type/Design</b>
                          </td>
                          <td>
                            <b>Construction (GF/FF/SF)</b>
                          </td>
                        </tr>
                      </thead>
                      <tbody>
                        {Object.entries(checkedDesigns)
                          .filter(([key, value]) => value)
                          .map(([key]) => {
                            const design = standardDesigns?.find((item) => String(item.code) === String(key));
                            if (!design) return null;
                            return (
                              <tr key={design.code}>
                                <td>{design.code}</td>
                                <td>{design.areaSqm || "-"}</td>
                                <td>{design.dimension || "-"}</td>
                                <td>{design.typeDesign || "-"}</td>
                                <td>
                                  {design.construction
                                    ? `GF: ${design.construction.GF}, FF: ${design.construction.FF}, SF: ${design.construction.SF}`
                                    : "-"}
                                </td>
                              </tr>
                            );
                          })}
                      </tbody>
                    </Table>
                  </TableContainer>
                </Col>
              </Row>
            )}
            {(watchProjectType === "Building Design as per standard Drawing" ||
              watchProjectType === "Standard condition as per Lease deed/freehold deed") &&
              watchisSpecialProject === "yes" && (
                <Row>
                  <Col>
                    {" "}
                    <InputWrapper
                      control={control}
                      label={t("Ground Coverage")}
                      placeholder={t("Enter Ground Coverage")}
                      name="groundCoverages"
                      defaultValue={formData?.groundCoverages || formData?.groundCoverage}
                      type="textInput"
                      mandatory
                      disabled={isEmployee}
                      validation={{
                        required: {
                          value: true,
                          message: "This field is required",
                        },
                      }}
                      maxLength={4}
                    />
                  </Col>

                  <Col>
                    {" "}
                    <InputWrapper
                      control={control}
                      label={t("FAR")}
                      placeholder={t("Enter FAR")}
                      name="fars"
                      defaultValue={formData?.fars || formData?.far}
                      type="textInput"
                      mandatory
                      disabled={isEmployee}
                      validation={{
                        required: {
                          value: true,
                          message: "This field is required",
                        },
                      }}
                      maxLength={4}
                    />
                  </Col>
                </Row>
              )}

            {(watchProjectType === "Building Design as per standard Drawing" ||
              watchProjectType === "Standard condition as per Lease deed/freehold deed") &&
              watchisSpecialProject === "yes" && (
                <Row>
                  <Col>
                    {" "}
                    <InputWrapper
                      control={control}
                      label={t("Building Height")}
                      placeholder={t("Enter Building Height")}
                      name="buildingHeight"
                      defaultValue={formData?.buildingHeight}
                      type="textInput"
                      mandatory
                      disabled={isEmployee}
                      validation={{
                        required: {
                          value: true,
                          message: "This field is required",
                        },
                      }}
                      maxLength={4}
                    />
                  </Col>
                  <Col>
                    <InputWrapper
                      control={control}
                      label={t("Number of floor permissible")}
                      placeholder={t("Enter floors")}
                      name="anyotherCondition"
                      defaultValue={formData?.anyotherCondition}
                      type="textInput"
                      mandatory
                      disabled={true}
                      validation={{
                        required: {
                          value: true,
                          message: "This field is required",
                        },
                      }}
                    />
                  </Col>
                </Row>
              )}

            {(watchProjectType === "Building Design as per standard Drawing" ||
              watchProjectType === "Standard condition as per Lease deed/freehold deed") &&
              watchisSpecialProject === "yes" && (
                <Row>
                  <Col>
                    <InputWrapper
                      label={t("Front")}
                      control={control}
                      placeholder={t("Enter Front")}
                      name="previousSetbackFront"
                      mandatory
                      disabled={isEmployee}
                      maxLength={2}
                      defaultValue={formData?.previousSetbackFront || formData?.setbackFronts}
                      type="textInput"
                      validation={{
                        required: {
                          value: true,
                          message: "This field is required",
                        },
                      }}
                    />
                  </Col>
                  <Col>
                    {" "}
                    <InputWrapper
                      label={t("Rear")}
                      control={control}
                      placeholder={t("Enter Rear")}
                      name="previousSetbackRear"
                      mandatory
                      disabled={isEmployee}
                      maxLength={2}
                      defaultValue={formData?.previousSetbackRear || formData?.setbackRears}
                      type="textInput"
                      validation={{
                        required: {
                          value: true,
                          message: "This field is required",
                        },
                      }}
                    />
                  </Col>
                </Row>
              )}

            {(watchProjectType === "Building Design as per standard Drawing" ||
              watchProjectType === "Standard condition as per Lease deed/freehold deed") &&
              watchisSpecialProject === "yes" && (
                <Row>
                  <Col>
                    <InputWrapper
                      label={t("Side Setback-1")}
                      control={control}
                      placeholder={t("Enter Side Setback-1")}
                      name="previousSetbackSide1"
                      mandatory
                      disabled={isEmployee}
                      maxLength={2}
                      defaultValue={formData?.previousSetbackSide1 || formData?.setbackSide1}
                      type="textInput"
                      validation={{
                        required: {
                          value: true,
                          message: "This field is required",
                        },
                      }}
                    />
                  </Col>
                  <Col>
                    {" "}
                    <InputWrapper
                      label={t("Side Setback-2")}
                      control={control}
                      placeholder={t("Enter Side Setback-2")}
                      name="previousSetbackSide2"
                      mandatory
                      disabled={isEmployee}
                      maxLength={2}
                      defaultValue={formData?.previousSetbackSide2 || formData?.setbackSide2}
                      type="textInput"
                      validation={{
                        required: {
                          value: true,
                          message: "This field is required",
                        },
                      }}
                    />
                  </Col>
                </Row>
              )}
            {fastPASData && fastPASData?.descriptionOfLand?.landArea < 40000 && watchlandUseType !== "Residential" && (
              <Row>
                <Col>
                  <InputWrapper
                    control={control}
                    data={yesOrNo}
                    label={`${t("Will You Pay Shelter Fee")}`}
                    name="shelterFee"
                    defaultValue={formData?.shelterFee}
                    type="radioButton"
                    mandatory
                    disabled={isEmployee}
                    validation={{
                      required: {
                        value: true,
                        message: "This field is required",
                      },
                    }}
                  />
                </Col>
                <Col></Col>
              </Row>
            )}
            {/* Additional Detail */}
            {/* <Row>
              <Col>
                <InputWrapper
                  control={control}
                  label="Does proposal contain Purchasable FAR?"
                  name="containFAR"
                  type="radioButton"
                  mandatory
                  data={yesOrNo}
                  defaultValue={formData?.containFAR}
                  validation={{
                    required: {
                      value: true,
                      message: "This field is required",
                    },
                  }}
                />
              </Col>
            </Row> */}
            {/* <Row>
              <Col>
                <InputWrapper
                  label={t("Is Your Plot sub-divided without permission")}
                  control={control}
                  name="plotSubdivided"
                  mandatory
                  data={yesOrNo}
                  defaultValue={formData?.plotSubdivided}
                  type="radioButton"
                  validation={{
                    required: {
                      value: true,
                      message: "This field is required",
                    },
                  }}
                />
              </Col>
            </Row> */}
            {/* <Row>
              {watchPlotSubdivided === "no" && (
                <Col>
                  <InputWrapper
                    label={t("Does existing building require any compounding ?")}
                    control={control}
                    name="needCompounding"
                    mandatory
                    data={yesOrNo}
                    defaultValue={formData?.needCompounding}
                    type="radioButton"
                    validation={{
                      required: {
                        value: true,
                        message: "This field is required",
                      },
                    }}
                  />
                </Col>
              )}
            </Row> */}

            {/* <Row>
              {watchNeedComp === "no" && watchPlotSubdivided === "no" && (
                <Col>
                  <InputWrapper
                    label={t("Is your plot Lease hold ?")}
                    control={control}
                    name="plotLeaseHold"
                    mandatory
                    data={yesOrNo}
                    defaultValue={formData?.plotLeaseHold}
                    type="radioButton"
                    validation={{
                      required: {
                        value: true,
                        message: "This field is required",
                      },
                    }}
                  />
                </Col>
              )}
              {watchplotLeaseHold === "yes" && (
                <Col>
                  <FileUploader
                    label={"Noc For Lease Hold"}
                    control={control}
                    name="leaseholdNOC"
                    validationMsg="(jpg, jpeg, png file only and Max file Size 10 MB)"
                    required
                    isMandatory
                    tab={1}
                  />
                </Col>
              )}
            </Row> */}
            {watchPlotSubdivided === "yes" || watchplotLeaseHold === "yes" ? (
              <InfoBox>
                Not authorized for Self Certification Approval of Map <span>*</span>
              </InfoBox>
            ) : (
              watchNeedComp === "yes" && (
                <InfoBox>
                  Kindly apply on Compounding Module <span>*</span>
                </InfoBox>
              )
            )}
          </Container>
          {/* {fastPASData && (
            <TableContainer component={Paper} sx={{ marginBottom: "20px" }}>
              <Table sx={{ minWidth: 650 }} aria-label="drawing details  table">
                <TableHead
                  sx={{
                    backgroundColor: isEmployee ? "rgba(52, 73, 94, 0.94)" : "#1F4A7C",
                    color: "#fff",
                  }}
                >
                  <TableRow sx={{ height: "15px" }}>
                    {pFARColumns.map((column) => (
                      <TableCell key={column.id} sx={{ color: "#fff" }}>
                        {column.label}
                      </TableCell>
                    ))}
                  </TableRow>
                </TableHead>
                <TableBody>
                  <TableRow>
                    <TableCell>{Number.isFinite(baseFAR) ? baseFAR : "-"}</TableCell>
                    <TableCell>{Number.isFinite(purchasableFAR) ? purchasableFAR : "-"}</TableCell>
                    <TableCell>{Number.isFinite(premiumFAR) ? premiumFAR : "-"}</TableCell>
                  </TableRow>
                </TableBody>
              </Table>
            </TableContainer>
          )} */}
          <div className="formHeaderContainer">
            <h2 className="formHeading">{t("Purchasable Details")}</h2>
          </div>
          <Container fluid className="formInputContainer common-app-form">
            <Row>
              <Col>
                <InputWrapper
                  label={t("Basic FAR Factor")}
                  control={control}
                  name="basicFAR"
                  mandatory={true}
                  placeholder={t("Enter Basic FAR Factor")}
                  defaultValue={formData?.basicFAR}
                  type="specialChar"
                  onlyNumeric={true}
                  allowedChars="."
                  decimalScale={2}
                  formatOnBlur={true}
                  disabled={isEmployee}
                  // maxValue={Number.isFinite(baseFAR) ? baseFAR : undefined}
                  validation={{
                    required: {
                      value: true,
                      message: "This field is required",
                    },
                  }}
                />
              </Col>
              <Col>
                <InputWrapper
                  label={t("Purchasable FAR Factor")}
                  control={control}
                  name="purchasableFAR"
                  mandatory={true}
                  defaultValue={formData?.purchasableFAR}
                  type="specialChar"
                  disabled={isEmployee}
                  onlyNumeric={true}
                  allowedChars="."
                  decimalScale={2}
                  formatOnBlur={true}
                  // maxValue={Number.isFinite(purchasableFAR) ? purchasableFAR : undefined}
                  placeholder={t("Enter Purchasable FAR Factor")}
                  validation={{
                    required: {
                      value: true,
                      message: "This field is required",
                    },
                  }}
                />
              </Col>
            </Row>
            <Row>
              {watchlandUseType !== "Residential" &&
                watchPrimaryUse !== "Residential" &&
                (watchSubZoneType !== "Built-up" || watchSubZoneType !== "Grameen Abaadi" || watchSubZoneType !== "Residential") &&
                (watchAtivityProposed !== "Detached - Multi Units" ||
                  watchAtivityProposed !== "Detached - Single Units" ||
                  watchAtivityProposed !== "Row Housing - Multi units" ||
                  watchAtivityProposed !== "Row Housing - Single units" ||
                  watchAtivityProposed !== "Semi-detached - Multi Units" ||
                  watchAtivityProposed !== "Semi-Detached - Single Units") && (
                  <Col>
                    <InputWrapper
                      label={t("Premium FAR Factor")}
                      control={control}
                      name="premiumFAR"
                      mandatory
                      defaultValue={formData?.premiumFAR}
                      type="specialChar"
                      allowedChars="."
                      disabled={isEmployee}
                      // maxValue={Number.isFinite(premiumFAR) ? premiumFAR : undefined}
                      placeholder={t("Enter Premium FAR Factor")}
                      onlyNumeric={true}
                      decimalScale={2}
                      formatOnBlur={true}
                      validation={{
                        required: {
                          value: true,
                          message: "This field is required",
                        },
                      }}
                    />
                  </Col>
                )}
              <Col></Col>
            </Row>
            {!isEmployee && (
              <div className="formContainer bg-white">
                <FormControlLabel
                  style={{ padding: "10px 15px" }}
                  control={
                    <Checkbox
                      name="declaration"
                      control={control}
                      onChange={handleDeclarationChange}
                      rules={{ required: "You must agree to the terms and conditions" }}
                    />
                  }
                  label={
                    <span>
                      I hereby declare that all the details and information provided in this form are true and correct to the best of my knowledge and
                      belief.
                      <br /> I understand that any false or misleading information may result in rejection of the application or other appropriate
                      action.
                    </span>
                  }
                />
              </div>
            )}
          </Container>
        </div>

        {!isEmployee && (
          <div className="footerContainer">
            <div className="buttonWrapper">
              <ButtonWrapper
                variant="contained"
                color="success"
                size="medium"
                label="Save"
                type="submit"
                sx={{ backgroundColor: "#157CB3" }}
                disabled={
                  !declarationChecked ||
                  watchPlotSubdivided === "yes" ||
                  watchplotLeaseHold === "yes" ||
                  watchNeedComp === "yes" ||
                  watchContainFar === "yes"
                }
              />
            </div>
          </div>
        )}
      </form>
      {showToast && (
        <Toast error={showToast?.error} warning={showToast?.warning} label={t(showToast?.message)} onClose={closeToast} isDeleteBtn={true} />
      )}
    </section>
  );
};

export default SubStep1;
